import { useState } from 'react';

const API_URL = process.env.REACT_APP_API_BASE
    ? `${process.env.REACT_APP_API_BASE}/phpmailer/oznam.php`
    : '/phpmailer/oznam.php';

const inputClass = 'w-full border-b-2 border-gray-300 outline-none p-3 bg-transparent focus:border-red-600 transition-colors duration-200';

function AdminOznam() {
    const [form, setForm]     = useState({ title: '', message: '', password: '', location: 'stavebniny' });
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
        if (status) setStatus(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.title.trim() || !form.message.trim() || !form.password) return;

        setLoading(true);
        setStatus(null);

        try {
            const res  = await fetch(API_URL, {
                method:  'POST',
                headers: { 'Content-Type': 'application/json' },
                body:    JSON.stringify({
                    title:    form.title.trim(),
                    message:  form.message.trim(),
                    password: form.password,
                    location: form.location,
                }),
            });
            const data = await res.json();

            if (data.status === 'ok') {
                setStatus('ok');
                setForm({ title: '', message: '', password: '' });
            } else {
                setStatus(data.message || 'Nastala chyba.');
            }
        } catch {
            setStatus('Nepodarilo sa odoslať. Skontrolujte pripojenie.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6 py-16">
            <div className="bg-white rounded-2xl shadow-xl p-10 w-full max-w-lg">

                {/* Header */}
                <div className="flex items-center gap-3 mb-8">
                    <span className="bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">
                        Admin
                    </span>
                    <span className="text-xl font-bold text-gray-800">Petromin</span>
                </div>

                <h1 className="text-3xl font-bold text-gray-800 mb-1">Pridať oznam</h1>
                <p className="text-gray-400 text-sm mb-10">
                    Oznam sa zobrazí návštevníkom počas 3 dní od uloženia.
                </p>

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <input
                            type="text"
                            name="title"
                            placeholder="Titulok oznamu.."
                            className={inputClass}
                            value={form.title}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div>
                        <textarea
                            name="message"
                            placeholder="Text oznamu.."
                            rows={5}
                            className={`${inputClass} resize-none`}
                            value={form.message}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div>
                        <select
                            name="location"
                            className={inputClass}
                            value={form.location}
                            onChange={handleChange}
                        >
                            <option value="stavebniny">Stavebniny</option>
                            <option value="cerpacia_stanica">Čerpacia stanica</option>
                            <option value="obe">Obe stránky</option>
                        </select>
                    </div>

                    <div>
                        <input
                            type="password"
                            name="password"
                            placeholder="Heslo.."
                            className={inputClass}
                            value={form.password}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {status === 'ok' && (
                        <p className="text-green-600 font-semibold text-sm">
                            Oznam bol uložený. Návštevníci ho uvidia pri najbližšom načítaní stránky.
                        </p>
                    )}
                    {status && status !== 'ok' && (
                        <p className="text-red-600 font-semibold text-sm">{status}</p>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        className={`w-full py-4 rounded font-semibold text-white transition-colors duration-200 ${
                            loading
                                ? 'bg-gray-400 cursor-not-allowed'
                                : 'bg-red-600 hover:bg-red-700 cursor-pointer'
                        }`}
                    >
                        {loading ? 'Ukladám...' : 'Uložiť oznam'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AdminOznam;
